export class LoraForwarderGatewayConfiguration {
  public GatewayID!: string;

  public ServerAddress!: string;
  public ServPortUp!: number;
  public ServPortDown!: number;

  public KeepaliveInterval!: number;
  public StatInterval!: number;
  public PushTimeoutMs!: number;

  public ForwardCrcValid!: boolean;
  public ForwardCrcError!: boolean;
  public ForwardCrcDisabled!: boolean;
  public FakeGps!: boolean;
  public RefLatitude!: number;
  public RefLongitude!: number;
  public RefAltitude!: number;
  public GpsPath!: string;

  constructor(config: any) {
    this.GatewayID = config.gateway_ID;
    this.ServerAddress = config.server_address;
    this.ServPortUp = config.serv_port_up;
    this.ServPortDown = config.serv_port_down;

    this.KeepaliveInterval = config.keepalive_interval;
    this.StatInterval = config.stat_interval;
    this.PushTimeoutMs = config.push_timeout_ms;
    this.ForwardCrcValid = config.forward_crc_valid;
    this.ForwardCrcError = config.forward_crc_error;
    this.ForwardCrcDisabled = config.forward_crc_disabled;
    this.FakeGps = config.fake_gps;
    this.RefLatitude = config.ref_latitude;
    this.RefLongitude = config.ref_longitude;
    this.RefAltitude = config.ref_altitude;
    this.GpsPath = config.gps_tty_path;
  }
}
